import { render, staticRenderFns } from "./OurWorkView.vue?vue&type=template&id=2b8506d8&scoped=true&"
import script from "./OurWorkView.vue?vue&type=script&lang=js&"
export * from "./OurWorkView.vue?vue&type=script&lang=js&"
import style0 from "./OurWorkView.vue?vue&type=style&index=0&id=2b8506d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8506d8",
  null
  
)

export default component.exports